export enum ModelResponseFormat {
  JSON = 'json',
}

export enum ModelToolType {
  FUNCTION = 'function',
}

export enum ChatRole {
  SYSTEM = 'system',
  USER = 'user',
  ASSISTANT = 'assistant',
  TOOL = 'tool',
}

export * from './copilot';
